var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrice1Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd05e;}.cls-2{fill:#f7b64b;}.cls-3{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cout1_selected",
    "data-name": "cout1 selected"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.1,
    cy: 27.29,
    r: 11.06,
    transform: "translate(-4.89 48.41) rotate(-76.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 28.1,
    cy: 27.29,
    r: 8.02,
    transform: "translate(-4.89 48.4) rotate(-76.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrice1Selected);
export default __webpack_public_path__ + "static/media/icon_price_1_selected.c26ea8e645be0978f29dedc7d1af18df.svg";
export { ForwardRef as ReactComponent };